import { render } from "./NegociacoesComponent.vue?vue&type=template&id=4dc2ff02&scoped=true"
import script from "./NegociacoesComponent.vue?vue&type=script&lang=js"
export * from "./NegociacoesComponent.vue?vue&type=script&lang=js"

import "./NegociacoesComponent.vue?vue&type=style&index=0&id=4dc2ff02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc2ff02"]])

export default __exports__